<template>
  <div class="page-content users-table-view">
    <div class="container-fluid">
      <!-- <Card>
				<Row>
					<Col span="16">
						<span class="page-title">{{ $t('competition.groups') }}</span>
					</Col>
					<Col span="8" class="d-flex justify-content-end"> </Col>
				</Row>
			</Card> -->

      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>

      <div v-else class="mt-0 mt-md-2">
        <StatsModal v-if="modal" :team="selectedTeam" :competition="competition" :category="selectedCat" @close="() => {
            this.selectedTeam = null;
            this.modal = false;
            this.getTeams();
          }
          " />
        <TopScorersModal v-if="topScorerModal" :teams="categoryTeams" :competition="competition" @close="() => {
            this.categoryTeams = [];
            this.topScorerModal = false;
          }
          " />
        <Row v-if="competition && competition.stages.length" class="d-flex flex-wrap" :gutter="16">
          <Col v-for="category in categories" class="mt-0 mt-lg-4 mb-0 mb-lg-4 user-tabble-style" :key="category._id">
          <Card style="height: 100%;">
            <div class="d-flex justify-content-between w-100 first-table-row">
              <h3>{{ category.name }}</h3>
              <div class="d-flex align-items-center gap-3">
                <Button v-if="
                  isSuper &&
                  (competition.hasOwnProperty('isCompleted')
                    ? !competition.isCompleted
                    : true)
                " type="error" @click="forceCompetitionFinish">
                  <b>{{ $t("competition.finish") }}</b>
                </Button>
                <Button v-if="competition.enableStats" type="success" @click="() =>
                    openTopScorersModal(
                      teams
                        .filter(team => team.category._id === category._id)
                        .map(team => team._id)
                    )
                  ">
                  <b>{{ $t("competition.top_scorers") }}</b>
                </Button>
                <Button type="warning" :to="`/competition/brackets/${$route.params.id}/${category._id}`
                  " target="_blank">
                  <b>{{ $t("competition.scheme") }}</b>
                </Button>
              </div>
            </div>
            <div class="table-special-div">
              <table id="users-table" class="table table-bordered dt-responsive table-striped nowrap"
                style="margin-bottom: 0;">
                <thead class="teams-table-style">
                  <!-- <tr class="first-table-row">
											<th
												class="align-middle"
												style="font-size: 24px;"
												:colspan="teams.filter((team) => team.statistics).length ? 8 + competition.stages.length : 4"
											>
												<div class="d-flex justify-content-between">
													{{ category.name }}
													<div class="d-flex">
														<Button class="mr-2" type="warning" :to="`/competition/${$route.params.id}/${category._id}/schema`" target="_blank">
															<b>{{ $t('competition.scheme') }}</b>
														</Button>
														<Button type="warning" :to="`/competition/brackets/${$route.params.id}/${category._id}`" target="_blank">
															<b>{{ $t('competition.scheme') }}</b>
														</Button>
													</div>
												</div>
											</th>
										</tr> -->
                  <tr>
                    <th rowspan="2" style="width: 40px; max-width: 40px;"></th>
                    <th rowspan="2" style="width: 30%;">
                      {{ $t("menu.team") }}
                    </th>
                    <th class="total-top" colspan="2">
                      {{ $t("competition.total") }}
                    </th>
                    <th v-if="teams.filter(team => team.statistics).length" v-for="stage in competition.stages.filter(
                      stage => stage.category === category._id
                    )" colspan="2">
                      {{ stage.name }}
                    </th>
                  </tr>
                  <tr>
                    <th class="total">{{ $t("competition.points") }}</th>
                    <th class="total">{{ $t("competition.diff") }}</th>
                    <template v-if="teams.filter(team => team.statistics).length" v-for="_stage in competition.stages.filter(
                      stage => stage.category === category._id
                    )">
                      <th>{{ $t("competition.points") }}</th>
                      <th>{{ $t("competition.diff") }}</th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(team, k) in teams
                    .filter(team => team.category._id === category._id)
                    .sort(sortTeams)">
                    <tr v-if="team" :key="team._id" @click="() => openModal(team, category._id)" role="button">
                      <td>{{ k + 1 }}.</td>
                      <td>
                        <Tooltip :content="team.name" placement="top-start" style="width: max-content">
                          <span class="text-overflow-style single-groups-clamp-text w-100">
                            {{ team.name }}
                          </span>
                        </Tooltip>
                      </td>
                      <td class="total">
                        <span v-if="
                          team.statistics && team.statistics.totalPoints
                        ">{{ team.statistics.totalPoints }}</span>
                      </td>
                      <td class="total">
                        <div v-if="team.statistics" class="d-flex justify-content-between w-100 text-nowrap">
                          <span class="mr-2">
                            {{ team.statistics.totalScored }} -
                            {{ team.statistics.totalConceded }}
                          </span>
                          <span class="font-weight-bold">
                            ({{
                              displayPlus(
                                team.statistics.totalScored,
                                team.statistics.totalConceded
                              )
                            }})
                          </span>
                        </div>
                      </td>
                      <template v-if="team.statistics" v-for="stage in team.statistics
                        ? team.statistics.stages
                        : []">
                        <td>
                          <span v-if="stage">{{ stage.points }}</span>
                          <span v-else></span>
                        </td>
                        <td>
                          <div v-if="stage" class="d-flex justify-content-between w-100 text-nowrap">
                            <span class="mr-2">
                              {{ stage.scored }} - {{ stage.conceded }}
                            </span>
                            <span class="font-weight-bold">
                              ({{
                                displayPlus(stage.scored, stage.conceded)
                              }})
                            </span>
                          </div>
                          <span v-else></span>
                        </td>
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </Card>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import StatsModal from "./StatsModal.vue";
import TopScorersModal from "../brackets/TopScorersModal.vue";

export default {
  components: { StatsModal, TopScorersModal },
  data() {
    return {
      teams: [],
      loading: false,
      categories: [],
      modal: false,
      topScorerModal: false,
      selectedTeam: null,
      selectedCat: null,
      competition: null,
      isSuper: false
    };
  },
  watch: {
    teams: {
      deep: true,
      handler(n, o) {
        console.log({
          n: n.map(team => team.statistics && team.statistics.totalPoints),
          o: o.map(team => team.statistics && team.statistics.totalPoints)
        });
      }
    }
  },
  methods: {
    sortTeams(a, b) {
      if (a.statistics && b.statistics) {
        if (a.statistics.totalPoints !== b.statistics.totalPoints) {
          return b.statistics.totalPoints - a.statistics.totalPoints;
        }
        if (
          a.statistics.totalScored - a.statistics.totalConceded !==
          b.statistics.totalScored - b.statistics.totalConceded
        ) {
          return (
            b.statistics.totalScored -
            b.statistics.totalConceded -
            (a.statistics.totalScored - a.statistics.totalConceded)
          );
        }
        if (a.statistics.totalScored !== b.statistics.totalScored) {
          return b.statistics.totalScored - a.statistics.totalScored;
        }
      }
      if (a.name && b.name) {
        return a.name.localeCompare(b.name);
      }
      return 0;
    },
    async finishCompetition() {
      try {
        await this.$http.post("/competition/finish", {
          _id: this.competition._id
        });
        window.location.reload();
      } catch (error) {
        console.log(error);
      }
    },
    async forceCompetitionFinish() {
      this.$dialog
        .confirm(this.$t("global.confirmForceFinish"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          await this.finishCompetition();
        })
        .catch(error => {
          console.log(error);
        });
    },
    enableFor(arr) {
      if (!this.$user.data.role) return false;
      this.isSuper = arr.includes(this.$user.data.role[0]);
      console.log(this.isSuper, arr);
    },
    async getTeams() {
      try {
        const res = await this.$http.post("/team/list", {
          competition_id: this.$route.params.id
        });
        this.teams = res.data;
        this.teams
          // .filter(team => team.players.length >= team.ttype.max_count)
          .forEach(team => {
            if (!this.categories.some(cat => cat._id === team.category._id)) {
              this.categories.push(team.category);
            }
          });
        let extraTeams = [...this.teams];
        extraTeams.forEach(t => {
          for (let i = 0; i < t.statistics.stages.length; i++) {
            const stage = t.statistics.stages[i];
            t.statistics.stages[i].pts = stage.points;
          }
        });
        await this.teams.forEach(async team => {
          if (team.statistics) {
            team.statistics.stages.sort((a, b) =>
              a.stage.name.slice(-1) < b.stage.name.slice(-1) ? -1 : 1
            );

            let index = 1;
            while (
              team.statistics.stages.length <
              this.competition.stages.filter(
                stage => stage.category === team.category._id
              ).length
            ) {
              if (
                team.statistics.stages.some(
                  ({ stage }) => stage.name.slice(-1) === index.toString()
                )
              ) {
                index++;
              } else if (
                team.statistics.stages.some(
                  ({ stage }) => stage.name.slice(-1) > index.toString()
                )
              ) {
                team.statistics.stages.unshift({
                  stage: { _id: index, name: "Etapa " + index },
                  scored: 0,
                  conceded: 0,
                  points: 0
                });
              } else if (
                team.statistics.stages.some(
                  ({ stage }) => stage.name.slice(-1) < index.toString()
                )
              ) {
                team.statistics.stages.push({
                  stage: { _id: index, name: "Etapa " + index },
                  scored: 0,
                  conceded: 0,
                  points: 0
                });
              }
            }
            let counter = 0;

            for (let i = 0; i < team.statistics.stages.length; i++) {
              const stage = team.statistics.stages[i];
              let cond = this.competition.formats.find(
                format =>
                  format.stage === stage.stage._id &&
                  format.category._id === stage.stage.category
              );
              if (cond && cond.format_type === "group") {
                let standings = await this.getStandingsByStage(
                  [
                    this.competition.stages.find(
                      stag => stag._id === stage.stage._id
                    )
                  ],
                  stage.stage.category
                );

                console.log({
                  object: standings.map((rate) => {
                    return { name: rate.name };
                  })
                });

                standings.push(
                  ...this.teams
                    .filter(
                      team =>
                        standings.length &&
                        team.category._id === standings[0].category
                    )
                    .filter(
                      team =>
                        !standings.some(standing => standing._id === team._id)
                    )
                );
                standings.forEach(
                  place =>
                    (place.rating = standings.length - standings.indexOf(place))
                );
                let stand = standings.find(
                  standing => standing._id === team._id
                );
                if (stand) team.statistics.stages[i].points = stand.rating;
              }
              let arbitraryTeams =
                cond &&
                this.sortByCertainStageStats(
                  extraTeams,
                  cond.stage,
                  cond.category._id
                );
              if (cond && cond.count === "places") {
                team.statistics.stages[i].points =
                  arbitraryTeams.length -
                  arbitraryTeams.findIndex(item => item._id === team._id);
              }
              counter += team.statistics.stages[i].points;
            }

            team.statistics.totalScored = team.statistics.stages.reduce(
              (acc, item) => acc + item.scored,
              0
            );
            team.statistics.totalConceded = team.statistics.stages.reduce(
              (acc, item) => acc + item.conceded,
              0
            );
            team.statistics.totalPoints = counter;
            console.log(counter);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    sortByCertainStageStats(teams, myStage, cat) {
      if (this.competition) {
        let arbitraryIndex = this.competition.stages.find(
          stage => stage.category === cat && stage._id === myStage
        );
        console.log({ arbitraryIndex, myStage, teams });
        return teams
          .filter(team => team.category._id === cat)
          .sort((a, b) => {
            if (a.statistics && b.statistics) {
              let aStage = a.statistics.stages.find(
                stag => stag.stage._id === arbitraryIndex._id
              );
              let bStage = b.statistics.stages.find(
                stag => stag.stage._id === arbitraryIndex._id
              );
              if (aStage && bStage) {
                if (aStage.pts !== bStage.pts) {
                  return bStage.pts - aStage.pts;
                }
                const goalDiffA = aStage.scored - aStage.conceded;
                const goalDiffB = bStage.scored - bStage.conceded;
                if (goalDiffA !== goalDiffB) {
                  return goalDiffB - goalDiffA;
                }
                if (aStage.scored !== bStage.scored) {
                  return bStage.scored - aStage.scored;
                }
              }
              return this.sortTeams(a, b);
            }
            return 0;
          });
      }
    },
    async getStandingsByStage(stages, cat) {
      let stageMatches = [];
      try {
        const res = await this.$http.post("/match/getManyFromPlayoff", {
          stages: stages,
          category: cat
        });
        stageMatches.push(...res.data);
      } catch (error) {
        console.log(error);
      }
      return this.getStandings(stageMatches);
    },
    getStandings(matchList, destArray) {
      let playoffs;
      if (!matchList) playoffs = this.playoffs;
      else playoffs = matchList;
      if (playoffs.every(match => match.isFinished)) {
        let neededPlayoffMatches = [...playoffs].filter(match => {
          let neededFinal = playoffs.find(
            final =>
              final.placement === "final" &&
              final.bracketIndex === match.bracketIndex
          );
          if (match.placement === "semifinal") {
            return match.playoffStage === neededFinal.playoffStage - 2;
          } else if (match.placement === "quarterfinal") {
            return match.playoffStage < 0;
          } else {
            return match;
          }
        });
        for (let i = 0; i < neededPlayoffMatches.length; i++) {
          const element = neededPlayoffMatches[i];

          const placementSchema = ["quarterfinal", "semifinal", "final"];
          neededPlayoffMatches[i].rating =
            placementSchema.indexOf(element.placement) +
            +element.isUpperBracket +
            element.playoffStage -
            element.bracketIndex * 10;
        }
        if (!destArray) {
          let testArray = [];
          let ratedPlayoffs = neededPlayoffMatches.sort((a, b) =>
            a.rating > b.rating ? -1 : 1
          );
          for (let i = 0; i < ratedPlayoffs.length; i++) {
            const element = ratedPlayoffs[i];
            this.formStandings(element, testArray);
          }
          return testArray;
        }
        let ratedPlayoffs = neededPlayoffMatches.sort((a, b) =>
          a.rating > b.rating ? -1 : 1
        );
        for (let i = 0; i < ratedPlayoffs.length; i++) {
          const element = ratedPlayoffs[i];
          this.formStandings(element, destArray);
        }
      }
    },
    formStandings(element, destArray) {
      if (
        this.getPoints(element.home_players, element, element.home_team) >
        this.getPoints(element.away_players, element, element.away_team)
      ) {
        if (!destArray.some(team => team._id === element.home_team._id))
          destArray.push(element.home_team);
        if (!destArray.some(team => team._id === element.away_team._id))
          destArray.push(element.away_team);
      } else {
        if (!destArray.some(team => team._id === element.away_team._id))
          destArray.push(element.away_team);
        if (!destArray.some(team => team._id === element.home_team._id))
          destArray.push(element.home_team);
      }
    },
    getPoints(arr, match, team) {
      if (arr && arr.length && match) {
        if (match.tech_loser) {
          if (match.tech_loser === team._id) return 0;
          else return 28;
        }
        return arr.reduce((acc, item) => acc + item.points, 0);
      }
      return 0;
    },
    async getCurrentCompetition() {
      try {
        const res = await this.$http.post("/competition/find", {
          _id: this.$route.params.id
        });
        this.competition = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    displayPlus(scored, conceded) {
      let diff = scored - conceded;
      if (diff > 0) {
        return "+" + diff;
      } else if (Number.isNaN(diff)) {
        return "...";
      } else {
        return diff;
      }
    },
    openModal(team, cat) {
      this.selectedTeam = team;
      this.selectedCat = cat;
      this.modal = true;
    },
    openTopScorersModal(teams) {
      this.categoryTeams = teams;
      this.topScorerModal = true;
    },
    findDuplicatesById(data) {
      const allItems = [];
      const duplicates = [];

      // Flatten the items from each object
      data.forEach(obj => {
        allItems.push(...obj.players);
      });

      // Object to keep track of unique _ids
      const seenIds = new Set();

      // Check for duplicates
      allItems.forEach(item => {
        const { _id } = item.player;

        if (seenIds.has(_id)) {
          // If _id is already in the seen set, it's a duplicate
          duplicates.push(item);
        } else {
          // Add the _id to the seen set
          seenIds.add(_id);
        }
      });

      return duplicates;
    }
  },
  async created() {
    this.loading = true;
    await this.getCurrentCompetition();
    await this.getTeams();

    await this.enableFor(["super"]);
    setTimeout(() => {
      this.loading = false;
    }, 1500);
    const duplicates = this.findDuplicatesById(this.teams);
    console.log({ duplicates });
  }
};
</script>

<style scoped>
@import url("../../../assets/global.css");

.min-vh-90 {
  min-height: 90vh;
}

.table {
  border-collapse: collapse;
}

.total-top {
  text-transform: uppercase;
}

.total {
  font-weight: bold;
}

/* tr:nth-child(odd) .total {
  background-color: white;
}
tr:nth-child(even) .total {
  background-color: #e8e8e8;
} */
.first-table-row {
  background: var(--bg-darkness);
  color: var(--text-color);
  border: 1px solid var(--bg-darkness);
  padding: 4px;
}

.first-table-row h3 {
  font-size: 24px;
  color: var(--text-color);
  font-weight: 600;
}

.gap-3 {
  gap: 5px;
}

.user-tabble-style {
  width: 100%;
}

.user-tabble-style .table tbody tr:hover,
.user-tabble-style .table-striped tbody tr:nth-of-type(odd):hover {
  background: #d3d3d3;
}

.user-tabble-style .table th,
.user-tabble-style .table td {
  padding: 4px;
  font-size: 13px;
}

.user-tabble-style .table-striped tbody tr:nth-of-type(odd) {
  background-color: #e8e8e8;
}

/* .user-tabble-style .table-bordered thead td, 
	.user-tabble-style .table-bordered thead th {
		border-bottom-width: 1px;
	} */

@media only screen and (max-width: 767.98px) {
  .user-tabble-style {
    padding: 0 !important;
  }

  .users-table-view .container-fluid {
    padding: 0 3px !important;
  }

  .user-tabble-style :global(.ivu-card-body) {
    padding: 10px;
  }

  .table-special-div {
    overflow-x: scroll;
  }
}

@media only screen and (max-width: 1536px) {
  .user-tabble-style {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/TeamsTable.vue